(function () {
  'use strict';

  function initPrimeCollectionsCarousel(section) {
    if (!section || section.dataset.primeCollectionsReady === 'true') {
      return;
    }

    section.dataset.primeCollectionsReady = 'true';

    var track = section.querySelector('[data-pcc-track]');
    var progress = section.querySelector('[data-pcc-progress]');
    var prev = section.querySelector('[data-pcc-prev]');
    var next = section.querySelector('[data-pcc-next]');
    var resizeTimer = null;

    if (!track) {
      return;
    }

    function getScrollAmount() {
      var card = track.querySelector('.prime-collections-carousel__card');
      var gap = 24;

      if (window.getComputedStyle) {
        var styles = window.getComputedStyle(track);
        gap = parseFloat(styles.columnGap || styles.gap || 24) || 24;
      }

      if (!card) {
        return track.clientWidth * 0.8;
      }

      return card.getBoundingClientRect().width + gap;
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function updateControls() {
      var maxScroll = getMaxScroll();
      var currentScroll = Math.max(0, track.scrollLeft);
      var tolerance = 3;

      if (progress) {
        if (maxScroll <= 0) {
          progress.style.width = '100%';
        } else {
          var visibleProgress = ((currentScroll + track.clientWidth) / track.scrollWidth) * 100;
          progress.style.width = Math.max(0, Math.min(100, visibleProgress)) + '%';
        }
      }

      if (prev) {
        prev.disabled = maxScroll <= 0 || currentScroll <= tolerance;
      }

      if (next) {
        next.disabled = maxScroll <= 0 || currentScroll >= maxScroll - tolerance;
      }
    }

    function scrollByCard(direction) {
      track.scrollBy({
        left: getScrollAmount() * direction,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollByCard(1);
      });
    }

    track.addEventListener('scroll', updateControls, { passive: true });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateControls, 80);
    });

    updateControls();
    window.setTimeout(updateControls, 250);
  }

  function initAllPrimeCollectionsCarousels() {
    document.querySelectorAll('[data-prime-collections-carousel]').forEach(function (section) {
      initPrimeCollectionsCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPrimeCollectionsCarousels);
  } else {
    initAllPrimeCollectionsCarousels();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches && event.target.matches('[data-prime-collections-carousel]')
      ? event.target
      : event.target.querySelector('[data-prime-collections-carousel]');

    if (section) {
      initPrimeCollectionsCarousel(section);
    }
  });
})();
